import { useEffect, useState } from 'react';

import { ElcanoCombo } from './ElcanoCombo';

export function PhoneRegionPicker({ ...props }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get('/geo/countries?v2')
      .then(function (response) {
        setLoading(false);

        let data = response.data.data;
        data = data.map(item => ({
          label: '+' + item.phone_code + ' (' + item.name + ')',
          value: item.iso2,
          order: item.phone_code,
        }));

        setData(data);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        // always executed
      });
  }, []);

  return <ElcanoCombo disabled={loading} loading={loading} data={data} clearAction={false} {...props} />;
}
